



































































import { editFactory } from '@/main/pages';
import { Partner } from '@/modules/kartoteka/partner';
import { NakladoveStredisko } from '@/modules/ciselnik/firemni/nakladoveStredisko';
import { VozidloPujcovna } from '@/modules/pujcovna/vozidloPujcovna';

import DmsPdfDialog from '#components/DmsPdfDialog.vue';

import { NAME, STAV_PLATBY_NEZAPLACENO } from './constants';
import { store } from './store/edit';
import { editMutations } from './store/types';
import { apiProvider } from './api';

export default editFactory(NAME, store).extend({
	components: {
		PartnerSelect: Partner.components.Select,
		NakladoveStrediskoSelect: NakladoveStredisko.components.Select,
		VozidloPujcovnaSelect: VozidloPujcovna.components.Select,
		DmsPdfDialog,
	},
	data() {
		return {
			tiskDialog: { visible: false, provider: null as ((filter: {}) => Promise<any>) | null },
		};
	},
	computed: {
		mutationsMappers(): Record<string, string> {
			return {
				nakladoveStredisko: `${this.storeUri}/${editMutations.NAKLAD_STREDISKO_SELECT_MAPPER}`,
				vozidlo: `${this.storeUri}/${editMutations.ZAPUJCKA_VOZIDLO_FILTER_SELECT_MAPPER}`,
				zakaznik: `${this.storeUri}/${editMutations.ZAPUJCKA_ZAKAZNIK_FILTER_SELECT_MAPPER}`,
			};
		},
		vozidloFilter(): object {
			return { PujcovnaId: this.PujcovnaId };
		},
		naklStredFilter(): object {
			return { ProvozovnaId: this.ProvozovnaId };
		},
		disabledSkodaUhradaDat(): boolean {
			return this.StavplatbyPzn === null || this.StavplatbyPzn === STAV_PLATBY_NEZAPLACENO;
		},
		disabledRozsirProtokolSkoda(): boolean {
			return !this.isEditMode || !this.TiskDat || !!this.FakturaceDat;
		},
		disabledInputs(): boolean {
			return this.isEditMode && (!!this.TiskDat || !!this.FakturaceDat);
		},
	},
	watch: {
		StavplatbyPzn() {
			if (this.disabledSkodaUhradaDat) {
				this.SkodaUhradaDat = null;
			}
		},
	},
	methods: {
		async tiskProtokoluClick() {
			try {
				this.startLoading();
				if (this.isCreateMode) await this.changeToEdit();
				if (this.isModified) await this.save(false);
				this.tiskDialog.provider = () => apiProvider.protokolaHlaseniOSkode({ SkodaHlaspaId: this.SkodahlaspaId });
				this.tiskDialog.visible = true;
			} finally {
				this.endLoading();
			}
		},
		async printDialogClosed() {
			try {
				this.startLoading();
				await this.refreshPage();
			} finally {
				this.endLoading();
			}
		},
		rozsirProtokolSkodaClick() {
			this.DokladPfx = null;
			this.DokladNr = null;
			this.TiskDat = null;
		},
	},
});
